import script from "./PlatformBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformBlock.vue?vue&type=script&setup=true&lang=js"

import "./PlatformBlock.vue?vue&type=style&index=0&id=2b7a8b0e&lang=scss"

const __exports__ = script;

export default __exports__